<template>
  <div class="display-flex flex-wrap">
    <div
      v-for="(item, key) in list"
      :key="key"
      class="mt-choose-item margin-b-12 margin-r-12"
      @click="chooseMt(item, 'all')"
      @mouseenter="activeIndex = item.twinslatorId"
      @mouseleave="activeIndex = -1"
      v-if="list.length > 0"
    >
      <div class="flex-center mt-icon-box">
        <EngineTag :item="item"></EngineTag>
        <svg aria-hidden="true" class="icon">
          <use :xlink:href="'#' + item.iconName"></use>
        </svg>
        <div class="btn-box" v-if="activeIndex === item.twinslatorId">
          <EditOutlined class="add-tip-icon" @click.stop="addTipsClick(item)" />
          <CloseOutlined
            v-if="item.userPrompt"
            class="add-tip-icon"
            @click.stop="delTips(item)"
          />
        </div>
      </div>
      <div class="text-center color-333 font-size-12 padding-t-6 white-1">
        {{ item.twinslatorName }}
      </div>
      <div class="mt-price">{{ item.price }}译力/千字</div>
    </div>
    <div v-else class="padding-l-20 font-size-12 color-999">暂无数据</div>
  </div>

  <a-modal
    :visible="addVisible"
    width="560px"
    :centered="true"
    :mask-closable="false"
    @cancel="addCancel"
  >
    <template #title>
      <p class="font-size-16 color-333">
        <span>自定义大模型提示语</span>
      </p>
    </template>
    <div>
      <a-textarea
        v-model:value.trim="tipsValue"
        placeholder="请输入大模型提示语"
        allow-clear
        show-count
        :maxlength="150"
      />
    </div>
    <template #footer>
      <div class="footer-button text-right">
        <a-button @click="addCancel">取消</a-button>
        <a-button type="primary" :disabled="!tipsValue" @click="addConfirm">
          保存
        </a-button>
      </div>
    </template>
  </a-modal>

  <a-modal
    :visible="delVisible"
    width="560px"
    :centered="true"
    :mask-closable="false"
    @cancel="delCancel"
  >
    <template #title>
      <p class="font-size-16 color-333">
        <span>自定义大模型提示语</span>
      </p>
    </template>
    <div>
      <p class="text-center">
        <img src="@/images/bigWarning.png" width="48" />
      </p>
      <p class="font-size-16 color-333 text-center margin-t-16 margin-b-8">
        是否删除大模型提示语？
      </p>
      <p class="font-size-14 color-999 text-center">
        大模型提示语：{{ mtDetail.userPrompt }}
      </p>
    </div>
    <template #footer>
      <div class="footer-button text-right">
        <a-button @click="delCancel">取消</a-button>
        <a-button type="primary" @click="delConfirm">删除</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script setup>
  import {
    postTwinslatorPromptSave,
    postTwinslatorPromptDelete,
  } from '@/http/api'
  import { ref, watch, computed } from 'vue'
  import { EditOutlined, CloseOutlined } from '@ant-design/icons-vue'
  import { message } from 'ant-design-vue'

  const emit = defineEmits(['update:parentVisible', 'onChange', 'get-list'])
  const props = defineProps({
    list: {
      type: Array,
      default: [],
    },
    parentVisible: {
      type: Boolean,
      default: false,
    },
  })
  const activeIndex = ref(-1)
  const addVisible = ref(false)
  const tipsValue = ref('')
  const mtDetail = ref({})
  const addTipsClick = (item) => {
    emit('update:parentVisible', false)
    addVisible.value = true
    mtDetail.value = item
    item.userPrompt && (tipsValue.value = item.userPrompt)
  }
  const addCancel = () => {
    tipsValue.value = ''
    addVisible.value = false
  }
  const addConfirm = () => {
    postTwinslatorPromptSave({
      twinslatorId: mtDetail.value.twinslatorId,
      prompt: tipsValue.value,
    }).then((res) => {
      message.success('保存成功')
      emit('get-list')
      addCancel()
    })
  }
  const delVisible = ref(false)
  const delTips = (item) => {
    emit('update:parentVisible', false)
    mtDetail.value = item
    delVisible.value = true
  }
  const delCancel = () => {
    delVisible.value = false
  }
  const delConfirm = () => {
    postTwinslatorPromptDelete(mtDetail.value.twinslatorId).then((res) => {
      message.success('删除成功')
      emit('get-list')
      delCancel()
    })
  }
  const chooseMt = (item, type) => {
    emit('onChange', item, type)
  }
</script>

<style lang="scss" scoped>
  .mt-common {
    padding: 20px 0 20px 20px;
    height: calc(100% - 48px);
    overflow-y: auto;
    &::-webkit-input-placeholder {
      font-size: 14px;
      color: #818385;
    }
    &::-webkit-scrollbar {
      width: 7px;
      background-color: rgba(0, 0, 0, 0);
    }
    &::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 10px;
      width: 7px;
    }
  }
  .mt-choose-item {
    position: relative;
    //height: 90px;
    width: 74px;
    cursor: pointer;
    &:hover {
      .icon {
        width: 20px;
        height: 20px;
      }
    }
  }
  .mt-icon-box {
    width: 48px;
    height: 48px;
    background: #f5f5f5;
    border-radius: 50%;
    margin: 0 auto;
    position: relative;
    .icon {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      cursor: pointer;
    }
    .btn-box {
      position: absolute;
      bottom: 0;
      right: -30px;
      width: 40px;
      .add-tip-icon {
        padding: 2px;
        &:hover {
          background: #eee;
          border-radius: 4px;
        }
      }
    }
  }
  .mt-price {
    font-size: 12px;
    color: #bbb;
    text-align: center;
  }
</style>
